/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NegotiationProposalAliases {
  BUTTON_ACCEPT = 'button-accept',
  BUTTON_NEW_PROPOSAL = 'button-new-proposal',
  BUTTON_REFUSE = 'button-refuse',
  CARD_PROPOSAL = 'card-proposal',
  CARD_REPORT = 'card-report',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  CONTEXTUAL_BAR_1 = 'contextual-bar-1',
  DECK_REPORTS = 'deck-reports',
  FETCH_0 = 'fetch-0',
  FETCH_NEGOTIATION_PROPOSAL = 'fetch-negotiation-proposal',
  FETCH_REPORTS = 'fetch-reports',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_CANCEL_REASON = 'field-cancel-reason',
  FIELD_ICON = 'field-icon',
  FIELD_MESSAGE = 'field-message',
  FIELD_MESSAGE_ACCEPT = 'field-message-accept',
  FIELD_MESSAGE_NEW_PROPOSAL = 'field-message-new-proposal',
  FIELD_PROPOSAL = 'field-proposal',
  FIELD_SEND_DATE = 'field-send-date',
  FIELD_STATUS = 'field-status',
  FIELD_VALIDITY_DATE = 'field-validity-date',
  FORM_0 = 'form-0',
  FORM_ACCEPT = 'form-accept',
  FORM_NEW_PROPOSAL = 'form-new-proposal',
  FORM_REFUSE = 'form-refuse',
  IMAGE_0 = 'image-0',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  MODAL_ACCEPT = 'modal-accept',
  MODAL_NEW_PROPOSAL = 'modal-new-proposal',
  MODAL_REFUSE = 'modal-refuse',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_3 = 'panel-3',
  PANEL_ACCEPT = 'panel-accept',
  PANEL_BUTTONS = 'panel-buttons',
  PANEL_NEGOTIATION_PROPOSAL = 'panel-negotiation-proposal',
  PANEL_NEW_PROPOSAL = 'panel-new-proposal',
  PANEL_REFUSE = 'panel-refuse',
  PANEL_REPORTS = 'panel-reports',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_AREA_0 = 'text-area-0',
  TEXT_AREA_ACCEPT = 'text-area-accept',
  TEXT_AREA_NEW_PROPOSAL = 'text-area-new-proposal',
}
export { NegotiationProposalAliases };
